<ion-card>
    <ion-fab vertical="center" horizontal="end">
        <ion-fab-button (click)="meterReadingsModal()" size="small" color="light">
            <ion-icon name="alarm"></ion-icon>
        </ion-fab-button>
    </ion-fab>
    <ion-card-content>
        <ion-label>Meter Readings: {{ document.serviceJob.meterReadings ? document.serviceJob.meterReadings.length : 0 }}</ion-label>
    </ion-card-content>
</ion-card>
